<template>
  <div class="auth-shell">
    <div class="container auth">
      <div class="auth-frame" :class="{'auth-frame--wide': wide, 'auth-frame--card-first': cardFirstOnMobile}">
        <section class="auth-stage" :class="{'auth-stage--compact': compactStage}">
          <div class="auth-stage__head">
            <div class="auth-stage__topline">{{ eyebrow }}</div>
            <h1 class="auth-stage__title">{{ title }}</h1>
            <p v-if="intro" class="auth-stage__intro">{{ intro }}</p>
          </div>

          <div class="auth-stage__story">
            <p class="auth-stage__story-text">{{ asideText }}</p>
            <ul v-if="asideList.length" class="auth-stage__list">
              <li v-for="item in asideList" :key="item" class="auth-stage__list-item">
                <Icon icon="fa-pro-solid:arrow-right" />
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>

          <a href="https://manet-marketing.de" target="_blank" rel="noopener noreferrer" class="auth-stage__brand">
            <img src="@/assets/img/manet-single-logo.png" alt="MANET Marketing Logo" class="auth-stage__brand-logo" />
          </a>
        </section>

        <section class="auth-card">
          <div class="auth-card__inner">
            <a
              v-if="showMobileBrand"
              href="https://manet-marketing.de"
              target="_blank"
              rel="noopener noreferrer"
              class="auth-card__brand d-lg-none"
            >
              <img src="@/assets/img/manet-single-logo.png" alt="MANET Marketing Logo" class="auth-card__brand-logo" />
            </a>

            <div class="auth-card__header">
              <div class="auth-card__eyebrow">{{ eyebrow }}</div>
              <h2 class="auth-card__title">{{ cardTitle || title }}</h2>
              <p v-if="cardIntro" class="auth-card__intro">{{ cardIntro }}</p>
            </div>

            <slot />

            <p v-if="footnote" class="auth-card__footnote">{{ footnote }}</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  props: {
    eyebrow: {
      type: String,
      default: 'Zugang'
    },
    title: {
      type: String,
      default: 'Willkommen zurück'
    },
    intro: {
      type: String,
      default: ''
    },
    cardTitle: {
      type: String,
      default: ''
    },
    cardIntro: {
      type: String,
      default: ''
    },
    asideText: {
      type: String,
      default: 'Verwalten Sie Ihre Vermarktung für dutzende Portale mit nur wenigen Klicks.'
    },
    asideList: {
      type: Array,
      default: () => []
    },
    footnote: {
      type: String,
      default: ''
    },
    wide: {
      type: Boolean,
      default: false
    },
    cardFirstOnMobile: {
      type: Boolean,
      default: true
    },
    compactStage: {
      type: Boolean,
      default: false
    },
    showMobileBrand: {
      type: Boolean,
      default: false
    }
  }
}
</script>
